import React, { forwardRef } from "react";
import { ActivityIndicator } from "react-native";
import { styleConstantsV2 as C } from "~/style/styleConstantsV2";
import type { ActivityIndicatorProps } from "react-native";

const SpinnerV2 = forwardRef<ActivityIndicator, ActivityIndicatorProps>(
  function Spinner(
    {
      size = "large",
      color = C.colorPrimary,
      ...props
    }: ActivityIndicatorProps,
    ref,
  ) {
    return <ActivityIndicator ref={ref} size={size} color={color} {...props} />;
  },
);

export { SpinnerV2 };
